import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  className?: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 text-center';
  const variants = {
    primary: 'bg-gradient-to-r from-[#D4850A] to-[#B8720A] text-white shadow-[0_0_20px_rgba(212,133,10,0.3)] hover:shadow-[0_0_30px_rgba(212,133,10,0.5)]',
    secondary: 'bg-white text-[#3D2B1F] border border-[#D4850A]/30 hover:border-[#D4850A] hover:bg-[#FEF3E2]'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl w-full max-w-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (onClick) {
      onClick(e);
    } else if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  if (href) {
    return <a href={href} onClick={handleClick} className={classes} data-id="element-212">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={classes} {...props} data-id="element-213">
      {children}
    </button>;
}